export default __webpack_public_path__ + "static/media/inprogress.279e80e8.wav";